module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/16-3a58008c7287f7ae19e19253ed953662.jpg";